export const quoteFilters = [
  {
    id: 1,
    name: "All",
    value: "all",
  },
  {
    id: 2,
    name: "Draft",
    value: "draft",
  },
  {
    id: 3,
    name: "Submitted",
    value: "submitted",
  },
  {
    id: 4,
    name: "Submitted",
    value: "sent_to_supplier",
  },
  {
    id: 5,
    name: "Order Placed",
    value: "order_placed",
  },
  {
    id: 6,
    name: "Quote Received",
    value: "assigned_to_customer",
  },
  {
    id: 7,
    name: "Declined",
    value: "declined",
  },
  {
    id: 8,
    name: "Expired",
    value: "expired",
  },
  {
    id: 9,
    name: "Order Failed",
    value: "order_failed",
  },
];


export const quoteStatusMapping = {
  draft: "Draft",
  submitted: "Submitted",
  sent_to_supplier: "Submitted",
  order_placed: "Order Placed",
  assigned_to_customer: "Quote Received",
  declined: "Declined",
  expired: "Expired",
  order_failed: "Order Failed",
};
